import React from "react";
import PropTypes from "prop-types";

import FileIncidentDownloadDialog from "./FileIncidentDownloadDialog";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const FileIncidentDownloadButton = ({
  className,
  incidentId,
  hasEvidencePendingReview,
}) => {
  const [open, setOpen] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  const handleFileClaimClick = () => {
    setOpen(true);
  };
  const handleCloseAccountRequest = () => {
    setOpen(false);
  };
  const handleAccountRequestSent = () => {
    setSent(true);
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Download incident">
        <Button
          size="small"
          variant="outlined"
          startIcon={<Icon>download</Icon>}
          onClick={handleFileClaimClick}
          className={className}
        >
          Download
        </Button>
      </Tooltip>
      <FileIncidentDownloadDialog
        onClose={handleCloseAccountRequest}
        onSent={handleAccountRequestSent}
        incidentId={incidentId}
        open={open}
        hasEvidencePendingReview={hasEvidencePendingReview}
      />
      <Snackbar
        open={sent}
        autoHideDuration={8000}
        onClose={() => setSent(false)}
        message={"Download is being processed"}
      />
    </>
  );
};

FileIncidentDownloadButton.propTypes = {
  incidentId: PropTypes.string.isRequired,
  hasEvidencePendingReview: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default FileIncidentDownloadButton;
